module.exports = __webpack_public_path__ + "img/Stretched-Canvases---Framed.7af00be6.jpg";